import Banner from "../components/Faqs/Banner/Banner";
import Tabs from "../components/Faqs/Tabs/Tabs";
import HelmetLayout from "../components/GlobalComponents/HelmetLayout";

const Faqs = () => {
    return (
        <HelmetLayout
            name="FAQs"
            title="FAQs | Ard Altaamir Services & Support"
            description="Find answers to common questions about Ard Altaamir’s renovation, repair, and maintenance services, pricing, and project timelines."
            route="faqs"
        >
            <Banner />
            <Tabs />
        </HelmetLayout>
    );
};

export default Faqs;
